import { Controller, Payload } from "../../config/controller";
import store, { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { Atendimento, initialValueAtendimentoState, AtendimentoState, AtendimentoActions, SessaoAtendimento, SetShowModalChamarPaciente, initialValueAtendimento } from "./atendimento.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { isEmpty } from "../../services/utils";
import { Paciente } from "../paciente/paciente.model";

export interface AtendimentoViewProps {
    atendimentoState: AtendimentoState
    atendimentoActions: AtendimentoActions
}


class AtendimentoController extends Controller<Atendimento, AtendimentoState, AtendimentoActions> {
    constructor() {
        super(initialValueAtendimentoState.row.type, initialValueAtendimentoState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            startAtendimento: `@${this.moduloName}/START_ATENDIMENTO`,
            abrirNovoAtendimento: `@${this.moduloName}/ABRIR_NOVO_ATENDIMENTO`,
            readAtendimentoToday: `@${this.moduloName}/READ_ATENDIMENTO_TODAY`,
            continuarAtendimento: `@${this.moduloName}/CONTINUAR_ATENDIMENTO`,
            setShowModalChamarPaciente: `@${this.moduloName}/SET_SHOW_MODAL_CHAMAR_PACIENTE`,
            getPacienteChamando: `@${this.moduloName}/GET_PACIENTE_CHAMANDO`,
            fecharSessaoAtendimento: `@${this.moduloName}/FECHAR_SESSAO_ATENDIMENTO`

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            startAtendimento: () => action(this.actionsType.startAtendimento),
            abrirNovoAtendimento: (sessao: SessaoAtendimento) => action(this.actionsType.abrirNovoAtendimento, { sessao }),
            readAtendimentoToday: () => action(this.actionsType.readAtendimentoToday),
            continuarAtendimento: (row) => action(this.actionsType.continuarAtendimento, { row }),
            setShowModalChamarPaciente: (prm) => action(this.actionsType.setShowModalChamarPaciente, { prm }),
            getPacienteChamando: (paciente) => action(this.actionsType.getPacienteChamando, { paciente }),
            fecharSessaoAtendimento: () => action(this.actionsType.fecharSessaoAtendimento)


        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.startAtendimento, this.startAtendimentoEffects.bind(this)),
            takeLatest(this.actionsType.abrirNovoAtendimento, this.abrirNovoAtendimentoEffects.bind(this)),
            takeLatest(this.actionsType.readAtendimentoToday, this.readAtendimentoTodayEffects.bind(this)),
            takeLatest(this.actionsType.continuarAtendimento, this.continuarAtendimentoEffects.bind(this)),
            takeLatest(this.actionsType.setShowModalChamarPaciente, this.setShowModalChamarPacienteEffects.bind(this)),
            takeLatest(this.actionsType.getPacienteChamando, this.getPacienteChamandoEffects.bind(this)),
            takeLatest(this.actionsType.fecharSessaoAtendimento, this.fecharSessaoAtendimentoEffects.bind(this)),

        ]
    }

    private * setShowModalChamarPacienteEffects(actions: Payload) {
        try {
            let prm: SetShowModalChamarPaciente = actions.payload.prm;
            const { chamar, finaliza, paciente, setModal } = { ...prm };
            let showMsg = ""
            if (!finaliza) {
                paciente.chamando = chamar;
                paciente.dt_hr_chamada = new Date().toISOString();
                paciente.situacao = "CHAMADO";
                paciente.atendimento = {
                    ...paciente.atendimento,
                    _id: this.state.row._id,
                    sala_desc: this.state.row.sala_atendimento ? this.state.row.sala_atendimento.descricao : "",
                }
                showMsg = `Preparando para chamar o paciente ${paciente.nome}...`
            } else {
                paciente.dt_hr_saida = new Date().toISOString();
                paciente.situacao = "FINALIZADO";
                showMsg = `Finalizando atendimento...`;
            }
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, status: "", msg: showMsg },
                this.actionsType.setShowModalChamarPaciente
            ));

            let respUpdate: ResultDb<Paciente> = yield call(this.db.salvar, paciente);
            if (respUpdate.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: "ok", msg: "Concluido!", pacienteChamado: respUpdate.row, showModalChamarPaciente: setModal },
                    this.actionsType.setShowModalChamarPaciente
                ));
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: respUpdate.status, msg: respUpdate.msg as string },
                    this.actionsType.setShowModalChamarPaciente
                ));
            }
        } catch (error: any) {
            console.log("error setShowModalChamarPaciente", error);
            let msg = "Ops, ocorreu uma falha em setShowModalChamarPaciente, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, status: "error", msg: err, error: true, showAlert: true },
                this.actionsType.continuarAtendimento
            ));
        }
    }

    private * getPacienteChamandoEffects(actions: Payload) {
        try {
            let paciente = actions.payload.paciente as Paciente
            let respGet: ResultDb<Paciente> = yield call(this.db.getDocID, paciente._id)
            if (respGet.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: "ok", msg: "Concluido!", pacienteChamado: respGet.row },
                    this.actionsType.setShowModalChamarPaciente
                ));
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: "error", msg: "Falha ao buscar a situação do chamado do paciente, detalhes: " + respGet.msg, showAlert: true },
                    this.actionsType.setShowModalChamarPaciente
                ));
            }
        } catch (error: any) {
            console.log("error getPacienteChamandoEffects", error);
            let msg = "Ops, ocorreu uma falha em getPacienteChamandoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, status: "error", msg: err, error: true, showAlert: true },
                this.actionsType.continuarAtendimento
            ));

        }
    }

    private * continuarAtendimentoEffects(actions: Payload) {
        try {
            let row: Atendimento = actions.payload.row;
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, status: "", msg: "Continuando sessao de atendimento..." },
                this.actionsType.readAtendimentoToday
            ));

            let respUpdate: ResultDb<Atendimento> = yield call(this.db.salvar, row);
            if (respUpdate.status === "ok") {
                let newSessao: SessaoAtendimento = {
                    medico: respUpdate.row.medico,
                    sala: respUpdate.row.sala_atendimento
                }
                localStorage.setItem("sessao", JSON.stringify(newSessao))
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: "ok", msg: "Sessão de atendimento iniciada!", row: respUpdate.row, sessaoStarted: true, sessao: newSessao },
                    this.actionsType.abrirNovoAtendimento
                ));

            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, status: "error", msg: respUpdate.msg as string, error: true, showAlert: true },
                    this.actionsType.continuarAtendimento
                ));
            }
        } catch (error: any) {
            console.log("error continuarAtendimentoEffects", error);
            let msg = "Ops, ocorreu uma falha em continuarAtendimentoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, status: "error", msg: err, error: true, showAlert: true },
                this.actionsType.continuarAtendimento
            ));
        }
    }

    private * fecharSessaoAtendimentoEffects(actions: Payload) {
        try {

            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, status: "", msg: "Encerrando sessao de atendimento..." },
                this.actionsType.fecharSessaoAtendimento
            ));
            localStorage.setItem("sessao", JSON.stringify({}))
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, status: "ok", msg: "Sessão de atendimento encerrada!", row: initialValueAtendimento, sessaoStarted: false, sessao: {} as SessaoAtendimento },
                this.actionsType.fecharSessaoAtendimento
            ));

        } catch (error: any) {
            console.log("error fecharSessaoAtendimentoEffects", error);
            let msg = "Ops, ocorreu uma falha em fecharSessaoAtendimentoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, status: "error", msg: err, error: true, showAlert: true },
                this.actionsType.fecharSessaoAtendimento
            ));
        }
    }

    private * readAtendimentoTodayEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: true, status: "", msg: "Buscando atendimento do dia..." },
                this.actionsType.readAtendimentoToday
            ));

            //buscar atendimento com a data atual
            let dataIni = new Date();
            dataIni.setHours(0, 0, 0);
            let dtIni = dataIni.toISOString();

            let dataFim = new Date();
            dataFim.setHours(23, 59, 59);
            let dtFim = dataFim.toISOString()

            var resp: ResultDb<Atendimento> = yield call(this.db.filter, {
                fieldsFilter: [
                    { fieldName: "type", mangoQuery: "$eq", fieldValue: this.moduloName },
                    {
                        fieldName: "data", mangoQuery: "$and", fieldValue: [{
                            "$gte": dtIni,
                            "$lte": dtFim,
                        }]
                    },
                ],
                indexName: "idx_atendimento_by_data"
            })
            if (resp.status === "ok") {

                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, status: "ok", msg: "Busca atendimento do dia concluida.", rows: resp.rows as Atendimento[], changeList: new Date().toISOString() },
                    this.actionsType.readAtendimentoToday
                ));
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loadingRows: false, status: resp.status, msg: resp.msg as string, rows: [] },
                    this.actionsType.readAtendimentoToday
                ));
            }
        } catch (error: any) {
            console.log("error readAtendimentoTodayEffects", error);
            let msg = "Ops, ocorreu uma falha em readAtendimentoTodayEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loadingRows: false, status: "error", msg: err, error: true, showAlert: true },
                this.actionsType.readAtendimentoToday
            ));
        }
    }


    private * abrirNovoAtendimentoEffects(actions: Payload) {
        try {
            const sessao: SessaoAtendimento = actions.payload.sessao;
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, status: "", msg: "Abrindo sessão de atendimento..." },
                this.actionsType.abrirNovoAtendimento
            ));

            let resp: ResultDb<Atendimento> = yield call(this.abrirNovoAtendimento, sessao)
            if (resp.status === "ok") {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: "ok", msg: "Sessão de atendimento iniciada!", row: resp.row, sessaoStarted: true, sessao: sessao },
                    this.actionsType.abrirNovoAtendimento
                ));
            } else {
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: resp.status, msg: resp.msg as string, error: true, showAlert: true },
                    this.actionsType.abrirNovoAtendimento
                ));
            }

        } catch (error: any) {
            console.log("error abrirNovoAtendimentoEffects", error);
            let msg = "Ops, ocorreu uma falha em abrirNovoAtendimentoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, status: "error", msg: err, error: true, showAlert: true },
                this.actionsType.abrirNovoAtendimento
            ));
        }

    }

    private * startAtendimentoEffects(actions: Payload) {
        console.log("chamou startAtendimentoEffects");
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: true, status: "", msg: "Iniciando ambiente para atendimento..." },
                this.actionsType.startAtendimento
            ));

            //verificar se tem sessao do atendimento no state
            let sessao: SessaoAtendimento = this.state.sessao;
            if (isEmpty(sessao)) {
                let sessaoStorage = localStorage.getItem("sessao")
                if (sessaoStorage)
                    sessao = JSON.parse(sessaoStorage)
            }
            console.log("sessao localizada", sessao)
            if (!isEmpty(sessao)) {
                //se tiver
                //buscar o registro do atendimento de acordo com os dados da sessao com a mesma data do dia
                let resp: ResultDb<Atendimento> = yield call(this.buscarAtendimentoByMedicoSala, sessao)
                if (resp.status === "ok") {
                    //carrega para o state
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, status: "ok", msg: "Ambiente de atendimento pronto!", row: resp.row, sessaoStarted: true },
                        this.actionsType.startAtendimento
                    ));

                } else {
                    //senao tiver
                    //mostra a tela para adicionar o registro de atendimento do dia
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, status: resp.status, msg: resp.msg as string, error: true, showAlert: true },
                        this.actionsType.startAtendimento
                    ));
                }
            } else {
                //mostra a tela para adicionar o registro de atendimento do dia
                yield put(this.reducer.resultAfterEffects(
                    { ...this.state, loading: false, status: "ok", msg: "Sessao de atendimento não está iniciada." },
                    this.actionsType.startAtendimento
                ));
            }

        } catch (error: any) {
            console.log("error startAtendimentoEffects", error);
            let msg = "Ops, ocorreu uma falha em startAtendimentoEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, status: "error", msg: err, error: true, showAlert: true },
                this.actionsType.startAtendimento
            ));
        }
    }

    abrirNovoAtendimento = async (sessao: SessaoAtendimento): Promise<ResultDb<Atendimento>> => {
        try {
            let novoAtendimento: Atendimento = {
                ...initialValueAtendimento,
                data: new Date().toISOString(),
                medico: sessao.medico,
                sala_atendimento: sessao.sala,
            }
            let respSalvar: ResultDb<Atendimento> = await this.db.salvar(novoAtendimento);
            console.log("respSalvar abrirNovoAtendimento", respSalvar);
            if (respSalvar.status === "ok" && respSalvar.row) {
                let newSessao: SessaoAtendimento = {
                    medico: respSalvar.row.medico,
                    sala: respSalvar.row.sala_atendimento
                }
                localStorage.setItem("sessao", JSON.stringify(newSessao))
            }
            return respSalvar;
        } catch (error: any) {
            console.log("error abrirNovoAtendimento", error);
            let msg = "Ops, ocorreu uma falha em abrirNovoAtendimento, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            return { status: "error", msg: err }
        }
    }


    buscarAtendimentoByMedicoSala = async (sessao: SessaoAtendimento): Promise<ResultDb<Atendimento>> => {
        try {
            //buscar atendimento com a data atual
            let data = new Date();
            data.setHours(0, 0, 0);
            let dtIni = data.toISOString();
            data.setHours(23, 59, 59);
            let dtFim = data.toISOString()

            var resp: ResultDb<Atendimento> = await this.db.filter({
                fieldsFilter: [
                    { fieldName: "type", mangoQuery: "$eq", fieldValue: this.moduloName },
                    {
                        fieldName: "data", mangoQuery: "$and", fieldValue: [{
                            "$gte": dtIni,
                            "$lte": dtFim,
                        }]
                    },
                ],
                indexName: "idx_atendimento_by_data"
            })
            console.log("resp buscarAtendimentoByMedicoSala", resp)
            if (resp.status === "ok") {
                if (resp.rows && resp.rows.length > 0) {
                    //filtrar os atendimento correspondente a sessao
                    let row = resp.rows.find((row) => (row.medico._id === sessao.medico._id && row.sala_atendimento._id === sessao.sala._id))
                    if(row !== undefined)
                        return { status: "ok", row: row }
                    return { status: "not_found" }
                }
                return { status: "not_found" }
            } else {
                return resp
            }
        } catch (error: any) {
            console.log("error buscarAtendimentoByMedicoSala", error);
            let msg = "Ops, ocorreu uma falha em buscarAtendimentoByMedicoSala, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            return { status: "error", msg: err, }
        }
    }
}

export const atendimentoController = new AtendimentoController()

export const mapStateToAtendimentoProps = (state: ApplicationState) => ({
    atendimentoState: state.atendimentoState,
})

export const mapDispatchToAtendimentoProps = (dispatch: Dispatch) => ({
    atendimentoActions: bindActionCreators({ ...atendimentoController.reducer.actions }, dispatch),
})

export const handleSelecionarAtendimento = (set: boolean) => {
    store.dispatch(atendimentoController.reducer.actions.setShowSelectModal(set));
    if (atendimentoController.state.rows.length === 0)
        store.dispatch(atendimentoController.reducer.actions.read())
}